import React,{useState , useEffect} from "react"
import {storage} from "../../firebase/index"
import Container from "@material-ui/core/Container"
import {makeStyles} from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';



const useStyles = makeStyles({
    root: {
        maxWidth: 500,
        backgroundColor:"transparent",

    },
    media: {
        height: 259,
    },
    container:{
        textAlign:"center"
    },
    dom:{
    paddingTop:"100px",
    },

    typography:{

        fontFamily:[
            'Luckiest Guy', "cursive"
               ],
        color:"white",
        font:"bold",
    },
    });



const db = storage.firestore()
const data=()=>{

    const classes = useStyles()
    const [users , setUsers ] = useState([])

    useEffect(()=>{
        const fetchUsers = async ()=>{
        const usersCollection = await db.collection("users").get()
                setUsers(usersCollection.docs.map(doc =>{
            return doc.data()
        }))   
        }
        fetchUsers()
    },[])

    return(
    <Container className={classes.dom}>  
        {users.map((user)=>{
    return(

        <Card className={classes.root}>
        <CardActionArea>
        <CardMedia
            className={classes.media}
            image={user.avatar}
            title={user.name}
        />
        <CardContent>
        <Typography gutterBottom variant="h4" component="h2" className={classes.typography}>
         {user.name}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p" className={classes.typography}>
          {user.description}
          </Typography>
        </CardContent>
      </CardActionArea>
      
    </Card>

     
    )
    })}
  
</Container>

    )

}
export default data







// WEBPACK FOOTER //
// ./src/Dimension/SliceOfLifeDimension/data.jsx